module.exports = __webpack_public_path__ + "img/kr-card-bottom-3.5b2fb57.png";